import Image from 'next/image';
import { Flex, Heading, SimpleGrid, Text } from '@chakra-ui/react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import FullPage from '@/src/components/UI/FullPage';
import OpenGraph from '@/components/OpenGraph';

function BrowserLogo({ src }: { src: string }) {
  return <Image src={src} width={96} height={96} layout='fixed' />;
}

export default function UpgradeBrowserPage() {
  return (
    <FullPage hasHeaderPlaceHolder>
      <OpenGraph />
      <Flex justify='center' align='center' mt={100} direction='column'>
        <Heading as='h2'>為了更好的瀏覽體驗</Heading>
        <Text fontSize='xl' mt={4}>
          請使用以下瀏覽器
        </Text>
        <SimpleGrid columns={3} spacing={4} mt={20}>
          <BrowserLogo src='/logo-chrome-browser.png' />
          <BrowserLogo src='/logo-firefox-browser.png' />
          <BrowserLogo src='/logo-edge-browser.png' />
        </SimpleGrid>
      </Flex>
    </FullPage>
  );
}

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
